
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/key-claim",
      function () {
        return require("private-next-pages/key-claim/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/key-claim"])
      });
    }
  